module.exports = __webpack_public_path__ + "static/media/barcodeImage_128.e36e1dfd.svg";